<template>
  <div class="row">
    <div class="col-md-9">
      <user-profile-page-preview :body="body"></user-profile-page-preview>
    </div>
    <div class="col-md-3">
      <UserSidebar v-if="id" :key="userKey" :id="id"> </UserSidebar>
    </div>
  </div>
</template>

<script>
import UserSidebar from "@/components/UserSidebarComponent";
import UserProfilePagePreview from "@/components/UserProfilePagePreview";

export default {
  data() {
    return {
      body: "",
      userKey: Math.random()
    };
  },
  props: ["id"], //user id
  components: {
    UserSidebar,
    UserProfilePagePreview
  },
  methods: {
    fetchProfile: function() {
      if (this.id !== undefined) {
        this.$axios
          .get(`/users/${this.id}/profile`)
          .then(res => (this.body = res.data.body));
      }
    }
  },
  mounted: function() {
    this.fetchProfile();
  }
};
</script>
